import {
	type MutateZeroQueriesMutationVariables,
	type QuickFindZeroQueriesQueryVariables,
	zeroQueriesMutation,
	zeroQueriesMutationV1,
	zeroQueriesQuery,
	zeroQueriesQueryV1,
	type ZeroQuery,
} from '@atlassian/search-client';

export const fetchZeroQueries = async (
	variables: QuickFindZeroQueriesQueryVariables,
	headers: Record<string, string>,
) =>
	await zeroQueriesQuery({ variables, headers }).then((response) => {
		const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
		const shuffledZeroQueries = [...zeroQueries].sort(() => Math.random() - 0.5);
		return shuffledZeroQueries.map(mapEssentialData);
	});

export const fetchZeroQueriesV1 = async (
	variables: QuickFindZeroQueriesQueryVariables,
	headers: Record<string, string>,
) =>
	await zeroQueriesQueryV1({ variables, headers }).then((response) => {
		const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueriesV1.zeroQueries || [];
		const shuffledZeroQueries = [...zeroQueries].sort(() => Math.random() - 0.5);
		return shuffledZeroQueries.map(mapEssentialData);
	});

export const mapEssentialData = (zeroQuery: ZeroQuery) => ({
	id: zeroQuery.query,
	title: zeroQuery.query,
	data: zeroQuery.query,
	product: zeroQuery.product,
	accountId: zeroQuery.accountId,
	avatarUrl: zeroQuery.avatarUrl,
	dateRange: zeroQuery.dateRange,
	type: 'zero-query' as const,
	zeroQueryType: zeroQuery.type,
});

export const mutateZeroQueries = async (
	variables: MutateZeroQueriesMutationVariables,
	headers: Record<string, string>,
) =>
	await zeroQueriesMutation({ variables, headers }).then(
		(response) => response.data?.knowledgeDiscovery.markZeroQueryInteracted.success ?? false,
	);

export const mutateZeroQueriesV1 = async (
	variables: MutateZeroQueriesMutationVariables,
	headers: Record<string, string>,
) =>
	await zeroQueriesMutationV1({ variables, headers }).then(
		(response) => response.data?.knowledgeDiscovery.markZeroQueryInteractedV1.success ?? false,
	);
